export const queryStringToObject = (locationSearch: string) => {
  if (locationSearch[0] !== '?') {
    return {};
  }

  const search = locationSearch.substring(1);

  if (!search) {
    return {};
  }

  return JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) =>
    key === '' ? value : decodeURIComponent(value)
  );
};
